import { render } from "./jydt.vue?vue&type=template&id=4f566c85&scoped=true"
import script from "./jydt.vue?vue&type=script&lang=js"
export * from "./jydt.vue?vue&type=script&lang=js"

import "./jydt.vue?vue&type=style&index=0&id=4f566c85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f566c85"]])

export default __exports__